import React, { Component } from "react";
import { Container } from "reactstrap";
import { connect } from "react-redux";
import SweetAlert from 'sweetalert2-react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { TabContent, TabPane, Nav, NavLink, NavItem } from "reactstrap";
import classnames from 'classnames';
import Dropzone from '../../common/DropzoneExample';
import { Link } from "react-router-dom";
import { withRouter } from 'react-router-dom';
import swal from "sweetalert";


import { activarCatalogoCobro, getCatalogoCobroDetail } from "./CatalogoCobroAction";
import CatalogoCobroVigente from "./CatalogoCobroVigente";


const mapStateToProps = (state) => {
	
	return {
		getCatalogoCobroActivar: state.CatalogoCobroReducer.getCatalogoCobroActivar,
		errorCatalogoCobroActivar: state.CatalogoCobroReducer.errorCatalogoCobroActivar
	};
};


class CatalogoCobroVigenteContainer extends Component {

	constructor(props) {
		super(props);
		this.state = {
			activeTab: 1,
			show: false,
		};
	}

	componentDidMount() {
		//console.log("Activar CATALOGO COBRO---------> "+this.props.match.params.id);
		this.props.dispatch(getCatalogoCobroDetail(this.props.match.params.id));
	}

	handleSubmit2(data) {
		//console.log("Activar handleSubmit ---------> " + this.props.match.params.id);
		this.props.dispatch(activarCatalogoCobro(data, this.props.match.params.id));
	}


	render() {
		const { activeTab } = this.state

		if (this.props.getCatalogoCobroActivar || this.props.errorCatalogoCobroActivar) {

			if (this.props.errorCatalogoCobroActivar || (this.props.getCatalogoCobroActivar != "OK")) {

				swal({
					title: this.props.getCatalogoCobroActivar,
					icon: "error",
					button: "Enterado"
				}
				).then((willDelete) => {
					this.props.history.push("/servicios");
				});

			} else {
				swal({
					title: "¡Servicio fue activado con éxito!",
					icon: "success",
					button: "Enterado"
				}
				)
					.then((willDelete) => {
						this.props.history.push("/servicios");
					});
			}//END ELSE

		}//END IF

		return (
			<>
				<div className="section-body">
					<div className="container-fluid">
						<div className="d-flex justify-content-between align-items-center ">
							<div className="header-action">
								<h1 className="page-title">Servicios</h1>
								<ol className="breadcrumb page-breadcrumb">
									<li className="breadcrumb-item"><a href="#">Administrativo</a></li>
									<li className="breadcrumb-item active" aria-current="page">Activar</li>
								</ol>
							</div>
							<Nav tabs className="page-header-tab">
								<NavItem>
									<Link to={"/servicios"}>Listar Servicios</Link>
								</NavItem>
							</Nav>

						</div>
					</div>
				</div>

				<div className="section-body mt-4">
					<div className="container-fluid">
						<TabContent activeTab={activeTab}>

							<TabPane tabId={1} className={classnames(['fade show'])}>


								<div className="row clearfix">
									<div className="col-lg-12 col-md-12 col-sm-12">
										<div className="card">
											<div className="card-header">
												<h3 className="card-title">Visualizar Servicios IEC</h3>
												<div className="card-options ">
													<a href="#" className="card-options-collapse" data-toggle="card-collapse"><i className="fe fe-chevron-up"></i></a>
													<a href="#" className="card-options-remove" data-toggle="card-remove"><i className="fe fe-x"></i></a>
												</div>
											</div>

											<CatalogoCobroVigente onSubmit={(data) => this.handleSubmit2(data)} />

										</div>
									</div>

								</div>

							</TabPane>


						</TabContent>
					</div>
				</div>

			</>
		);

	}//END RENDER


}

export default withRouter(connect(mapStateToProps, null)(CatalogoCobroVigenteContainer));

